import React from "react";
import BhumirajSweet from "../assets/case-studies/bhumiraj-web-cs.png";

export default function BhumirajSweetCaseStudy() {
  return (
    <div className="cs-pages">
      <img src={BhumirajSweet} alt="Bhumiraj Sweet" width={"80%"} />
    </div>
  );
}
